/**
 * GlobalAuth `admin: auth-method-weights` — share of the welcome bonus a user gets
 * for registering with / first linking a sign-in method, in percent. Admin-only;
 * a PATCH applies immediately (the service drops its weights cache).
 */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiOg } from './client';
const PATH = '/admin/auth-method-weights';
const KEY = ['og', 'auth-method-weights'];
export function useOgAuthMethodWeights() {
    return useQuery({ queryKey: KEY, queryFn: () => apiOg('auth', PATH) });
}
export function useUpdateOgAuthMethodWeight(authType) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (patch) => apiOg('auth', `${PATH}/${encodeURIComponent(authType)}`, {
            method: 'PATCH',
            body: patch,
        }),
        onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
    });
}
const AUTH_TYPE_LABELS = { telegram: 'Telegram', email: 'Почта' };
export function authTypeLabel(authType) {
    return AUTH_TYPE_LABELS[authType] ?? authType;
}
const WEIGHT_RE = /^\d+$/;
/**
 * Body for the PATCH: only the weights that changed (the API asks for exactly that).
 * null when nothing changed or an input isn't a whole number from 0 up.
 */
export function weightPatch(row, registration, link) {
    const reg = registration.trim();
    const lnk = link.trim();
    if (!WEIGHT_RE.test(reg) || !WEIGHT_RE.test(lnk))
        return null;
    const patch = {};
    if (Number(reg) !== row.registration_weight)
        patch.registration_weight = Number(reg);
    if (Number(lnk) !== row.link_weight)
        patch.link_weight = Number(lnk);
    return Object.keys(patch).length > 0 ? patch : null;
}
